import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Kbd } from "./kbd";

export interface TranslationLeafEditorProps {
  path: string[];
  reference: { language: string; value: string };
  value: string;
  onChange: (value: string) => void;
  onCancel: () => void;
  onSave: () => void;
}

export function TranslationLeafEditor({
  path,
  reference,
  value,
  onChange,
  onCancel,
  onSave,
}: TranslationLeafEditorProps) {
  return (
    <div className="space-y-3 rounded-5 border border-line bg-surface p-4">
      <div className="grid gap-3 sm:grid-cols-2">
        <div>
          <div className="font-mono text-[9.5px] uppercase tracking-[.12em] text-ink-500">
            Referentie · {reference.language}
          </div>
          <div className="mt-1 rounded-3 border border-dashed border-line-strong bg-surface px-3 py-2 italic text-[13px] text-ink-500">
            {reference.value}
          </div>
        </div>
        <div>
          <div className="font-mono text-[9.5px] uppercase tracking-[.12em] text-ink-500">
            Bewerken
          </div>
          <Textarea className="mt-1" value={value} onChange={(e) => onChange(e.target.value)} />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="font-mono text-[11px] text-ink-500">{path.join(" · ")}</div>
        <div className="flex items-center gap-2">
          <Button variant="ghost" onClick={onCancel}>
            Annuleren <Kbd>Esc</Kbd>
          </Button>
          <Button variant="primary" onClick={onSave}>
            Opslaan <Kbd inverted>⌘ S</Kbd>
          </Button>
        </div>
      </div>
    </div>
  );
}
